import React from 'react';
import Reveal from './Reveal';

export default function SectionHeader({ eyebrow, title, subtitle, centered = true }) {
  return (
    <div className={`section-header ${centered ? 'section-header--centered' : ''}`}>
      {eyebrow ? (
        <Reveal as="p" className="section-eyebrow" variant="fade-up" duration={700} threshold={0.2} distance={26}>
          {eyebrow}
        </Reveal>
      ) : null}

      <Reveal as="h2" className="section-title" variant="fade-up" duration={780} threshold={0.2} distance={30} delay={60}>
        {title}
      </Reveal>

      {subtitle ? (
        <Reveal as="p" className="section-subtitle" variant="fade-up" duration={820} threshold={0.2} distance={34} delay={140}>
          {subtitle}
        </Reveal>
      ) : null}
    </div>
  );
}
